import { Link, useNavigate } from "react-router-dom";
import { WakzyLogo } from "./WakzyLogo";
import { ArrowLeft, Home, Lock } from "lucide-react";
import { Button } from "./ui/button";
import { lockKiosk } from "./KioskGate";

export function KioskShell({ children, step, totalSteps, onBack, showExit = true }) {
  const navigate = useNavigate();
  const endSession = () => {
    lockKiosk();
    navigate("/kiosk-launch", { replace: true });
  };
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--wakzy-bg)" }}>
      <header className="sticky top-0 z-30 backdrop-blur-lg bg-[#030712]/80 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            {onBack && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onBack}
                className="text-slate-300 hover:text-white"
                data-testid="kiosk-back-btn"
              >
                <ArrowLeft className="w-4 h-4 mr-1" /> Back
              </Button>
            )}
            <WakzyLogo className="h-10" asLink={false} />
          </div>
          <div className="flex items-center gap-6">
            {typeof step === "number" && (
              <div className="flex items-center gap-2 text-sm text-slate-300">
                <span className="label-eyebrow">Step</span>
                <span className="font-heading text-xl text-white">{step}</span>
                <span className="text-slate-500">/ {totalSteps}</span>
              </div>
            )}
            {showExit && (
              <Button
                variant="ghost"
                size="sm"
                onClick={endSession}
                className="text-slate-400 hover:text-[#D4AF37]"
                data-testid="kiosk-exit-btn"
                title="End session — re-locks the tablet"
              >
                <Lock className="w-4 h-4 mr-1" /> End session
              </Button>
            )}
          </div>
        </div>
        {typeof step === "number" && (
          <div className="progress-track max-w-7xl mx-auto">
            <div
              className="progress-fill"
              style={{ width: `${(step / totalSteps) * 100}%` }}
            />
          </div>
        )}
      </header>
      <main className="flex-1">{children}</main>
    </div>
  );
}
